import { renderCamera, cameraResize, cameraAnimation } from "./camera";
import { renderControls, controlsAnimation } from "./controls";
import { PlanetProps } from "./../Data/planet";
import * as THREE from "three";
import light from "./light";
import logo, { logoAnimation } from "./logo";
import { renderPlanetArr, planetAnimation } from "./planet";

// const CENTER = new THREE.Vector3(0, 0, 0);
let localFocusId = "-1";
let preLocalFocusId = "-1";
let preLocalHoverId = "-1";
let localHoverId = "-1";

let touchId = "-1";

let TARGET_X = 0;
let TARGET_Y = 0;
let ORBIT_CHANGED = false;

let FRAMECOUNT = 0;
let NOWFRMAE_HOVER = 0;

let ZOOM_INIT = 4;

let loaded = false;

const render = (ref: React.RefObject<HTMLDivElement>, setNowId: any, data: PlanetProps[], zoom: number, setHoverId: any, setHomeLoaded: any, setZoomValue: any) => {
	if (ref !== null && ref.current !== null) {
		// SCENE
		const scene = new THREE.Scene();

		// CAMERA
		const camera = renderCamera(ZOOM_INIT);

		// RAYCASTER
		const rayCast = new THREE.Raycaster();
		const mouse = new THREE.Vector2();
		mouse.x = mouse.y = -1;

		// OBJECT
		light(scene);
		const logo_arr = logo(scene);
		const palnet_arr = renderPlanetArr(scene, data);

		// RENDERER
		const renderer = new THREE.WebGLRenderer({
			alpha: true
		});
		renderer.setSize(window.innerWidth, window.innerHeight);
		renderer.setClearColor(0x000000, 0);

		const onMouseClick = (e: any) => {
			console.log(ORBIT_CHANGED);
			if (ORBIT_CHANGED) return;

			if (e.type === "click") {
				mouse.x = (e.clientX / window.innerWidth) * 2 - 1;
				mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;
			} else if (e.type === "touchend") {
				mouse.x = (e.changedTouches[0].clientX / window.innerWidth) * 2 - 1;
				mouse.y = -(e.changedTouches[0].clientY / window.innerHeight) * 2 + 1;
			}

			rayCast.setFromCamera(mouse, camera);
			const intersects = rayCast.intersectObjects(scene.children);

			if (intersects[0]) {
				const id = intersects[0].object.name;
				if (e.type === "click") {
					setNowId(id);
				} else if (e.type === "touchend") {
					if (touchId === id) {
						setNowId(id);
					} else {
						setHoverId(id);
						touchId = id;
					}
				}
				localFocusId = id;
			} else {
				setNowId("");
				setHoverId("");
				localFocusId = "";
			}
		};

		const onMouseMove = (e: any) => {
			mouse.x = (e.clientX / window.innerWidth) * 2 - 1;
			mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;
			rayCast.setFromCamera(mouse, camera);

			const intersects = rayCast.intersectObjects(scene.children);

			if (intersects[0]) {
				const id = intersects[0].object.name;
				localHoverId = id;
				document.body.style.cursor = "pointer";
				setHoverId(id);
			} else {
				localHoverId = "";
				document.body.style.cursor = "auto";
				setHoverId("");
			}
		};

		renderer.domElement.addEventListener("click", onMouseClick, false);
		renderer.domElement.addEventListener("mousemove", onMouseMove, false);
		renderer.domElement.addEventListener("touchend", onMouseClick, false);

		ref.current.appendChild(renderer.domElement);

		// ORBIT CONTROLS
		const controls = renderControls(camera, renderer.domElement);

		controls.addEventListener("change", () => {
			if (!ORBIT_CHANGED) {
				ORBIT_CHANGED = true;
			}
		});

		controls.addEventListener("end", () => {
			setTimeout(() => {
				ORBIT_CHANGED = false;
			}, 100);
		});

		// ANIMATION
		const animate = function() {
			requestAnimationFrame(animate);
			FRAMECOUNT++;
			// LOADING
			if (FRAMECOUNT > 10 && !loaded) {
				loaded = true;
				setHomeLoaded((n: any) => ({ ...n, home: true }));
			}

			if (localHoverId !== preLocalHoverId) {
				NOWFRMAE_HOVER = FRAMECOUNT;
				preLocalHoverId = localHoverId;
			} else if (preLocalFocusId !== localFocusId) {
				NOWFRMAE_HOVER = FRAMECOUNT;
				preLocalFocusId = localFocusId;
			}

			// OBJECT ANIMATION
			logoAnimation(logo_arr, FRAMECOUNT);
			planetAnimation(palnet_arr, FRAMECOUNT, localFocusId, localHoverId, FRAMECOUNT - NOWFRMAE_HOVER);

			// CONTROLS ANIMATION
			controlsAnimation(controls, TARGET_X, TARGET_Y);

			// CAMERA ANIMATION
			cameraAnimation(camera, setZoomValue);

			renderer.render(scene, camera);
		};

		animate();

		window.addEventListener(
			"resize",
			() => {
				// OrthographicCamera camera
				cameraResize(camera);

				renderer.setSize(window.innerWidth, window.innerHeight);
			},
			false
		);
	}
};

export default render;
